import de from "./de";
import en from "./english";
import ru from "./ru";
import ssa from "./ssa";
import tur from "./tur";

export class Localizer {
    public static locale = 'en';

    public static languages = {
        en: {
            data: en,
            name: 'en'
        },
        de: {
            data: de,
            name: "de"
        },
        ru: {
            data: ru,
            name: "ru"
        },
        ssa: {
            data: ssa,
            name: "ssa"
        },
        tur: {
            data: tur,
            name: "tur"
        },
    }
}